// biome-ignore lint/style/noRestrictedImports: component usage
import type { TooltipProviderProps } from "@radix-ui/react-tooltip";
import { createContext, useContext } from "react";

/**
 * Context to determine if the tooltip is hidden.
 */
const TooltipContext = createContext(false);

export const TooltipContextProvider = TooltipContext.Provider;

export function useIsTooltipHidden(): boolean {
	return useContext(TooltipContext);
}

/**
 * Mirror the `TooltipProvider` so that the tooltip can be lazy loaded
 * without <React.Suspense><TooltipProvider /></React.Suspense> in the app,
 * otherwise it causes the remount of the entire app.
 */
export type TooltipConfig = Omit<TooltipProviderProps, "children">;

const TooltipConfigContext = createContext<TooltipConfig>({
	delayDuration: 700,
});

export const TooltipConfigContextProvider = TooltipConfigContext.Provider;

export function useTooltipConfig(): TooltipConfig {
	return useContext(TooltipConfigContext);
}
